import { CSSProperties } from 'react'
import jazzicon from '@metamask/jazzicon'
import MetamaskLogo from '../assets/images/metamask-logo.png'

const numberFromAddress = (address): number => {
  const addr = address.slice(2, 10)
  const seed = parseInt(addr, 16)
  return seed
}

const metamaskLogoStyle: CSSProperties = {
  position: 'absolute',
  borderRadius: '50%',
  width: '40%',
  left: '60%',
  right: '0',
  top: '60%',
  bottom: '0',
  border: '3px solid #0B1729',
  backgroundColor: '#0B1729'
}

interface IAccountImageProps {
  account: string
  showMetamaskLogo?: boolean
  size?: number
}

export const AccountImage = ({ account, showMetamaskLogo = false, size = 40 }: IAccountImageProps): JSX.Element => {
  const numericAddress = numberFromAddress(account)
  const accountImage = jazzicon(size, numericAddress).innerHTML
  const imageStyle: CSSProperties = {
    borderRadius: '50%',
    overflow: 'hidden',
    width: `${size}px`,
    height: `${size}px`
  }

  if (!showMetamaskLogo) {
    return <div dangerouslySetInnerHTML={{ __html: accountImage }} style={imageStyle}></div>
  } else {
    return (
        <div style={{
          position: 'relative',
          top: 0,
          left: 0,
          width: `${size}px`,
          height: `${size}px`
        }}>
            <div dangerouslySetInnerHTML={{ __html: accountImage }} style={{ position: 'relative', top: '0', left: '0', ...imageStyle }}></div>
            <img src={MetamaskLogo} alt="metamask logo" style={metamaskLogoStyle} />
        </div>
    )
  }
}
